// motion.ts
export const motionTokens = {
  "motion": {
    "duration": {
      "fast": {
        "value": "150ms",
        "type": "duration",
        "filePath": "design-tokens/motion.json",
        "isSource": true,
        "original": {
          "value": "150ms",
          "type": "duration"
        },
        "name": "MotionDurationFast",
        "attributes": {
          "category": "motion",
          "type": "duration",
          "item": "fast"
        },
        "path": [
          "motion",
          "duration",
          "fast"
        ]
      },
      "normal": {
        "value": "250ms",
        "type": "duration",
        "filePath": "design-tokens/motion.json",
        "isSource": true,
        "original": {
          "value": "250ms",
          "type": "duration"
        },
        "name": "MotionDurationNormal",
        "attributes": {
          "category": "motion",
          "type": "duration",
          "item": "normal"
        },
        "path": [
          "motion",
          "duration",
          "normal"
        ]
      },
      "slow": {
        "value": "400ms",
        "type": "duration",
        "filePath": "design-tokens/motion.json",
        "isSource": true,
        "original": {
          "value": "400ms",
          "type": "duration"
        },
        "name": "MotionDurationSlow",
        "attributes": {
          "category": "motion",
          "type": "duration",
          "item": "slow"
        },
        "path": [
          "motion",
          "duration",
          "slow"
        ]
      }
    },
    "easing": {
      "standard": {
        "value": "cubic-bezier(0.2, 0, 0, 1)",
        "type": "cubicBezier",
        "filePath": "design-tokens/motion.json",
        "isSource": true,
        "original": {
          "value": "cubic-bezier(0.2, 0, 0, 1)",
          "type": "cubicBezier"
        },
        "name": "MotionEasingStandard",
        "attributes": {
          "category": "motion",
          "type": "easing",
          "item": "standard"
        },
        "path": [
          "motion",
          "easing",
          "standard"
        ]
      },
      "emphasized": {
        "value": "cubic-bezier(0.2, 0, 0, 1)",
        "type": "cubicBezier",
        "filePath": "design-tokens/motion.json",
        "isSource": true,
        "original": {
          "value": "cubic-bezier(0.2, 0, 0, 1)",
          "type": "cubicBezier"
        },
        "name": "MotionEasingEmphasized",
        "attributes": {
          "category": "motion",
          "type": "easing",
          "item": "emphasized"
        },
        "path": [
          "motion",
          "easing",
          "emphasized"
        ]
      },
      "decelerate": {
        "value": "cubic-bezier(0, 0, 0.2, 1)",
        "type": "cubicBezier",
        "filePath": "design-tokens/motion.json",
        "isSource": true,
        "original": {
          "value": "cubic-bezier(0, 0, 0.2, 1)",
          "type": "cubicBezier"
        },
        "name": "MotionEasingDecelerate",
        "attributes": {
          "category": "motion",
          "type": "easing",
          "item": "decelerate"
        },
        "path": [
          "motion",
          "easing",
          "decelerate"
        ]
      },
      "accelerate": {
        "value": "cubic-bezier(0.4, 0, 1, 1)",
        "type": "cubicBezier",
        "filePath": "design-tokens/motion.json",
        "isSource": true,
        "original": {
          "value": "cubic-bezier(0.4, 0, 1, 1)",
          "type": "cubicBezier"
        },
        "name": "MotionEasingAccelerate",
        "attributes": {
          "category": "motion",
          "type": "easing",
          "item": "accelerate"
        },
        "path": [
          "motion",
          "easing",
          "accelerate"
        ]
      }
    }
  }
} as const;

export type MotionTokens = typeof motionTokens;
